/**
 * Reclamo de la prueba gratuita en español, sin tabla de idiomas alrededor.
 *
 * Es solo español porque las herramientas de guía que lo pintan (el generador
 * de cartas, el calendario, el certificado) solo existen en `es`. Vive en su
 * propio módulo porque una cadena suelta es client-safe: al no haber tablas de
 * los otros seis idiomas alrededor, el bundle del cliente paga exactamente esa
 * cadena. Mientras estaba en `template-print-copy.ts`, el `TRIAL_NOTE_ES` de
 * `call-bridge.tsx` arrastraba las siete tablas de la plantilla al chunk de
 * cada herramienta de guía (ADR-036, revisión de #450).
 *
 * La dirección autorizada es esta: `template-print-copy.ts` (módulo de
 * servidor) importa ESTA cadena para construir su tabla `TRIAL_NOTE`. La
 * contraria sigue prohibida por el guard `client/no-server-copy`.
 */
export const TRIAL_NOTE_ES = 'La primera llamada de bienvenida es gratis al registrarte.'
